var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68439 2.90625H17.1844C17.6603 2.90625 18.1167 3.0953 18.4532 3.43181C18.7897 3.76832 18.9788 4.22473 18.9788 4.70062V13.2188H4.89001V4.70062C4.89001 4.22473 5.07906 3.76832 5.41557 3.43181C5.75209 3.0953 6.20849 2.90625 6.68439 2.90625Z",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0876 19.7812H4.7832C4.50368 19.807 4.22216 19.7626 3.96412 19.6521C3.70608 19.5417 3.47968 19.3685 3.30542 19.1485C3.13116 18.9284 3.01454 18.6684 2.96614 18.3919C2.91773 18.1154 2.93906 17.8312 3.0282 17.565L4.89008 13.2188H18.9807L20.8444 17.565C20.9337 17.8313 20.955 18.1157 20.9065 18.3924C20.858 18.6691 20.7412 18.9292 20.5668 19.1493C20.3923 19.3695 20.1656 19.5425 19.9073 19.6529C19.649 19.7632 19.3672 19.8073 19.0876 19.7812Z",
    fill: "#E5E9FF",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93743 28.2188H17.4374C17.9133 28.2188 18.3697 28.4078 18.7062 28.7443C19.0428 29.0808 19.2318 29.5372 19.2318 30.0131V38.5313H5.13556V30.0131C5.13556 29.7769 5.18222 29.5429 5.27286 29.3247C5.36351 29.1065 5.49635 28.9084 5.66377 28.7417C5.83119 28.5749 6.02988 28.4429 6.24845 28.3532C6.46702 28.2635 6.70116 28.2178 6.93743 28.2188Z",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3331 45.0938H5.02875C4.74923 45.1195 4.4677 45.0751 4.20966 44.9646C3.95162 44.8542 3.72522 44.681 3.55096 44.461C3.3767 44.2409 3.26009 43.9809 3.21168 43.7044C3.16328 43.4279 3.18461 43.1437 3.27375 42.8775L5.13562 38.5312H19.2262L21.09 42.8775C21.1792 43.1438 21.2006 43.4282 21.1521 43.7049C21.1036 43.9816 20.9868 44.2417 20.8123 44.4618C20.6378 44.682 20.4111 44.855 20.1528 44.9654C19.8945 45.0757 19.6128 45.1198 19.3331 45.0938Z",
    fill: "#E5E9FF",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7768 3.84375H35.9643V6.65625",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6518 44.1562H35.9643V41.3438",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0938 21.6562H42.2812C42.2812 21.6562 45.0938 21.6562 45.0938 24.4688V32.9062C45.0938 32.9062 45.0938 35.7188 42.2812 35.7188H30.0938C30.0938 35.7188 27.2812 35.7188 27.2812 32.9062V24.4688C27.2812 24.4688 27.2812 21.6562 30.0938 21.6562Z",
    fill: "#E5E9FF",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 21.6956V18.8438C29.625 17.1033 30.3164 15.4341 31.5471 14.2034C32.7778 12.9727 34.447 12.2813 36.1875 12.2812C37.928 12.2812 39.5972 12.9727 40.8279 14.2034C42.0586 15.4341 42.75 17.1033 42.75 18.8438V21.6956",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.375 28.6875L35.25 30.5625L39 26.8125",
    stroke: "#3C4884",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.9544db4be9eca2134a669323658c6f7b.svg";
export { ForwardRef as ReactComponent };